export const applicationStatusMap = {
  incompleteDocumentPending: {
    value: "1",
    label: "Incomplete Documents/Pending Documents",
    hi: "अधूरे दस्तावेज़",
    color: "#ffe6e6",
  },
  incompleteInformation: {
    value: "2",
    label: "Incomplete Information By TIFC",
    hi: "टीआईएफसी द्वारा अधूरी जानकारी",
    color: "#f0f0f0",
  },
  tifcVerified: { value: "3", label: "Verified By TIFC", color: "#f0f0f0",hi: "टीआईएफसी द्वारा सत्यापित" },
  dlctUnverified: { value: "4", label: "Unverified By DLCT", color: "#e8f0fe", hi: "डीएलसीटी द्वारा असत्यापित" },
  dlctVerified: { value: "5", label: "Verified By DLCT", color: "#f0f0f0", hi: "डीएलसीटी द्वारा सत्यापित" },
  rejected: { value: "6", label: "Rejected", color: "#ffe6ff", hi: "नामंजूर" },
  approved: { value: "7", label: "Approved", color: "#e8f0fe", hi: "मंजूर" },
  applied: { value: "8", label: "Applied", color: "#e6ffff", hi: "आवेदन किया गया" },
  draft: { value: "9", label: "Draft", color: "#f0f0f0", hi: "अधूरा" },
  paymentDone: { value: "10", label: "Payment Done", color: "#f0f0f0", hi: "भुगतान हो गया" },
  nodalIncompleteInformation: {
    value: "11",
    label: "Incomplete Information By Nodal Officer",
    color: "#f0f0f0",
    hi: "नोडल अधिकारी द्वारा अधूरी जानकारी",
  },
};

export const applicationStatusList = Object.values(applicationStatusMap);

export const applicationStatusConfig = {
  incompleteDocumentPending: {
    label: "Incomplete Documents/Pending Documents",
    color: "#ffe6e6",
  },
  incompleteInformation: {
    label: "Incomplete Information By TIFC",
    color: "#f0f0f0",
  },
  tifcVerified: { label: "Verified By TIFC", color: "#f0f0f0" },
  dlctUnverified: { label: "Unverified By DLCT", color: "#e8f0fe" },
  dlctVerified: { label: "Verified By DLCT", color: "#f0f0f0" },
  rejected: { label: "Rejected", color: "#ffe6ff" },
  approved: { label: "Approved", color: "#e8f0fe" },
  draft: { label: "Draft", color: "#f0f0f0" },
  paymentDone: { label: "Payment Done", color: "#f0f0f0" },
  nodalIncompleteInformation: {
    label: "Incomplete Information By Nodal Officer",
    color: "#f0f0f0",
  },
};

export const applicationStageMap = {
  tifc: { value: "1", label: "TIFC", color: "#e6ffff" },
  dlct: { value: "2", label: "DLCT", color: "#ffe6e6" },
  slac: { value: "3", label: "SLAC", color: "#e8f0fe" },
  ddo: { value: "4", label: "DDO", color: "#ffe6ff" },
  user: { value: "5", label: "User", color: "#f0f0f0" },
};

export const applicationStageList = Object.values(applicationStageMap);

export const applicationStageConfig = {
  tifc: { label: "TIFC", color: "#f0f0f0" },
  dlct: { label: "DLCT", color: "#f0f0f0" },
  slac: { label: "SLAC", color: "#e6ffff" },
  ddo: { label: "DDO", color: "#ffe6ff" },
  user: { label: "User", color: "#f0f0f0" },
};

export const incentiveClaimTypes = {
  sreimbursementcapitalincentive: {
    value: "1",
    label: "Capital Subsidy/Stamp Duty Reimbursement",
    hi: "पूंजी सब्सिडी / स्टाम्प ड्यूटी प्रतिपूर्ति",
  },
  interestassistance: {
    value: "2",
    label: "Interest Assistance",
    hi: "ब्याज सहायता",
  },
};

export const incentiveClaimTypesList = Object.values(incentiveClaimTypes);

export const applicationStatusDoumentTypeMap = {
  incompleteDocumentPending: { value: "1", document: "tifc_unverified" },
  incompleteInformation: { value: "2", document: "tifc_unverified" },
  tifcVerified: { value: "3", document: "tifc_verified" },
  dlctUnverified: { value: "4", document: "dlct_unverified" },
  dlctVerified: { value: "5", document: "dlct_verified" },
  rejected: { value: "6", document: "slac_rejected" },
  approved: { value: "7", document: "slac_approved" },
  applied: { value: "8", document: null },
  draft: { value: "9", document: null },
  paymentDone: { value: "10", color: "#f0f0f0" },
  nodalIncompleteInformation: { value: "11", document: "nodal_unverified" },
};

export const applicationStatusDoumentTypeList = Object.values(
  applicationStatusDoumentTypeMap
);

